import type {CustomCopilotId} from '../utils/copilot-chat-types'
import {useChatManager} from '../utils/CopilotChatManagerContext'
import {customCopilotIdFromThread, useRouteSpaceId} from '../utils/custom-copilots-helpers'

/**
 * Pulls the selected custom copilot (space) from either the URL or the selected thread per the chat state.
 */
export function useSelectedCustomCopilotId(): CustomCopilotId | null {
  const manager = useChatManager()
  return useRouteSpaceId() || customCopilotIdFromThread(manager.getSelectedThread())
}
